export default __webpack_public_path__ + "static/media/MNR.166c51d7.png";